<template >
    <section class="content close-date-picker" style="position:relative;">
        <div :class="addButtonClass" class="common_save_btn">

            <router-link :to="{ name: 'surveysCreate', params: { _id: '0' } }">
                <button class=" btn gradientbt">+ Add Survey</button>
            </router-link>
        </div>

        <div class="main_select_wrp_relative">

            <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document" style="width: 50%">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2>Filters</h2>
                            <button type="button" class="close clearButton" data-dismiss="modal"
                                v-on:click="clearFilter">Clear All</button>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="main_select_wrp">
                                <div class="flex selectwca_wrp " v-if="this.adminCheck == 'superAdmin'">
                                    <!-- <div class="multiselected">
                                            <multiselect track-by="value" v-model="clearFilters.city.value" label="name" placeholder="Select City" :options="cityList" name="city" selectLabel="" deselectLabel="" selectedLabel="" @select="onCheckedCity" @remove="onRemoveCity"></multiselect>
                                        </div> -->
                                    <div class="multiselected">
                                        <label> Zone</label>
                                        <multiselect track-by="value" v-model="clearFilters.wasteCollectionArea.value"
                                            label="name" placeholder="Select Zone" :options="areas" :key="areas.length"
                                            @input="listRemove" multiple name="wasteArea" selectLabel="" deselectLabel=""
                                            selectedLabel="" @select="onChecked" @remove="onRemove"></multiselect>
                                    </div>
                                    <div class="multiselected">
                                        <label> CD</label>
                                        <multiselect track-by="value" v-model="clearFilters.collectionDivision.value"
                                            label="name" placeholder="Select CD" :options="collectionDivisions"
                                            :key="collectionDivisions.length" multiple name="divisions" selectLabel=""
                                            deselectLabel="" selectedLabel="" @select="onCheckedCd" @remove="onRemoveCD">
                                        </multiselect>
                                    </div>
                                    <div class="multiselected">
                                        <label>Status</label>
                                        <multiselect track-by="value" v-model="clearFilters.status.value" label="name"
                                            placeholder="Select Status" :options="status" :key="status.length" name="status"
                                            selectLabel="" deselectLabel="" selectedLabel="" @select="onSelectStatus"
                                            @remove="onRemoveStatus"></multiselect>
                                    </div>

                                </div>
                            </div>
                            <div class="select_date_wrp">

                                <div class="datedrop_boxs_wrp">

                                    <div class="datedrop_boxs">
                                        <div class="dates_left">
                                            <label>Surveyor</label>
                                            <multiselect track-by="value" v-model="clearFilters.surveyorId.value"
                                                label="name" placeholder="Select Surveyor" :options="surveyorPoints"
                                                :key="surveyorPoints.length" name="surveyorPoints" selectLabel=""
                                                deselectLabel="" selectedLabel="" @select="onCheckedSy"
                                                @remove="onRemoveSy"></multiselect>
                                        </div>
                                        <div class="dates_left">
                                            <label>Survey Status</label>
                                            <multiselect track-by="value" v-model="clearFilters.surveyStatus.value"
                                                label="name" placeholder="Select Survey Status" :options="statusTypes"
                                                multiple name="surveyStatus" selectLabel="" deselectLabel=""
                                                selectedLabel="" @select="onCheckedSt" @remove="onRemoveSt"></multiselect>
                                        </div>
                                        <div class="dates_left">
                                            <label>Schedule Start Date</label>
                                            <date-picker @change="startDate()" id="startDate" v-model="date.startDate"
                                                lang="en" name="startDate" required input-class="form-control"
                                                use-utc="true" width="100%" :format="'DD-MM-YYYY'"
                                                placeholder="Start date"></date-picker>

                                        </div>
                                        <!-- <div class="dates_left">
                                                <label>End Date</label>
                                                <date-picker @change="endDate()" :not-before="startDateIso" id="endDate" v-model="date.endDate" lang="en" name="endDate" required input-class="form-control" use-utc="true" width="100%" :format="'DD-MM-YYYY'" placeholder="End date"></date-picker>
                                            
                                            </div> -->
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="datedrop_boxs_wrapper">
            <div class="datedrop_boxs_inner datedrop_boxs_inner_survey">
                <div :class="addButtonClass" class="filter_survey_class">
                    <div class="filter_wrpp">
                        <button type="button" class="btn" data-toggle="modal" data-target="#filtertoogle">
                            <img src="../../../../static/img/pri_filter_icon.png">
                            Apply Filter
                            <span :class="{ 'counter_filter': count }">{{ count }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="isAreaTable" class="password-popup">
            <div class="password-popup-width">
                <h4 class="heading_pop">Line / Tower Details</h4>
                <a class="toggle" v-on:click="closeAreaTableModal">
                    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" x="0" y="0" version="1.1" viewBox="0 0 29 29"
                        xml:space="preserve">
                        <path fill="none" stroke="#706c6c" stroke-linecap="round" stroke-linejoin="round"
                            stroke-miterlimit="10" stroke-width="2"
                            d="M9.197 19.803L19.803 9.197M9.197 9.197l10.606 10.606" />
                    </svg>
                </a>
                <div class="table_scroll">
                    <table class="tablePopUp">
                        <tr>
                            <th>Line / Tower Name</th>
                            <th>Houses</th>
                        </tr>
                        <tr v-for="data in towersList">
                            <td>{{ data.towerName }}</td>
                            <td>{{ data.houses }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div v-on:click="closeAreaTableModal">
            <div class="box-body">
                <!-- <div :class="addButtonClass">
                    <router-link :to="{ name: 'surveysCreate', params: { _id: '0' } }">
                        <button class=" btn gradientbt">Add Survey</button>
                    </router-link>
                </div> -->
                <div class="surveysTable_scroll surveysTable_scroll_new">
                    <v-server-table ref="surveysTable" url :limit="5" :columns="columns" :options="options"
                        @loaded="onLoaded">
                        <template slot="beforeBody">
                            <tr v-if="loading" class="VueTables__no-results">
                                <td class="text-center" colspan="6">
                                    <pulse-loader></pulse-loader>
                                </td>
                            </tr>
                        </template>
                        <template slot="surveyStatus" slot-scope="props">
                            <div :class=props.row.surveyStatus>
                                {{ props.row.surveyStatus }}
                            </div>
                        </template>

                        <template slot="action" slot-scope="props">
                            <div class="active_wrp">
                                <div v-if="props.row.surveyStatus === 'Complete'" class="disableEdit">
                                    <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                                </div>
                                <div v-if="props.row.surveyStatus !== 'Complete'">
                                    <a class="fa fa-edit" role="button" v-on:click.stop="action(props.row)"></a>
                                </div>
                                <!-- <div class="c-pointer"> -->
                                <!-- <a class="fa fa-eye" role="button" v-on:click.stop="view(props.row)"></a> -->
                                <!-- <a class="pri_viewicon" role="button" v-on:click.stop="view(props.row)"> <img src="../../../../static/img/pri_viewicon.png"></a> -->
                                <!-- </div> -->
                                <div class="active_wrp" v-bind:style="{ cursor: 'pointer' }">
                                    <a class="fa fa-eye" role="button" v-on:click.stop="view(props.row)"></a>
                                </div>
                                <div class="py-2 text-center">
                                    <label class="toggle">
                                        <input class="toggle-checkbox" type="checkbox" :checked="props.row.status"
                                            @click.prevent="(e) => activateSurveysModal(props.row)" />
                                        <span class="slider"></span>
                                        <!-- <span class="labels" data-on="Active" data-off="Deactivate"></span> -->
                                    </label>
                                </div>
                            </div>
                        </template>
                        <template slot="lineTower" slot-scope="props">
                            <div class="active_wrp">
                                <a role="button" v-on:click.stop="showArea(props.row)">{{ props.row.lineTower }}</a>
                            </div>
                        </template>

                    </v-server-table>
                </div>
            </div>
        </div>
    </section>
</template>
    
<script>
import {
    eventBus,
    wasterecycleService,
    surveysService,
    segregationService,
    wasteCollectionAreaService,
} from "../../../services";
import {
    USER_ROLES
} from "../../../config";
import {
    ServerTable,
    Event
} from "vue-tables-2";
import {
    mapState
} from "vuex";
import store from "../../../store";
import swal from "sweetalert2";
import moment from "moment";
import dateFormatter from "../../utilities/dateFormate";
import {
    Multiselect
} from "vue-multiselect";

export default {
    name: "surveys",
    components: {
        Multiselect,
    },
    plantName: null,
    data() {
        return {
            clearFilters: {
                city: "",
                wasteCollectionArea: "",
                collectionDivision: "",
                surveyorId: "",
                surveyStatus: "",
                status: "",
            },
            date: {
                // startDate: "",
                // endDate: "",
            },
            endDateIso: "",
            startDateIso: "",
            list: [],
            // surveyorPointCYs: [],
            count: null,
            count1: 0,
            cityFilterCount: 0,
            zoneFilterCount: 0,
            cdFilterCount: 0,
            surveyorFilterCount: 0,
            statusFilterCount: 0,
            activeInactiveStatus: 0,
            sDateFilterCount: 0,
            surveyorPoints: [],
            adminCheck: {},
            towersList: [],
            isAreaTable: false,
            user1: [],
            loading: null,
            USER_ROLES: USER_ROLES,
            surveysTable: null,
            wcaShow: false,
            cdShow: false,
            checkedAreas: [],
            checkRole: "",
            checkedCds: [],
            filters: {},
            areas: [],
            cityList: [],
            parameters: {},
            collectionDivisions: [],
            statusTypes: [{
                name: "Complete",
                value: "complete"
            },
            {
                name: "Pending",
                value: "pending"
            },
            {
                name: "Ongoing",
                value: "ongoing"
            },
            {
                name: "Upcoming",
                value: "upcoming"
            },
            ],
            status: [{
                name: "Active",
                value: true
            },
            {
                name: "Inactive",
                value: false
            },
            ],
            checkedStatusType: [],
            columns: [
                // "surveyId",
                "wcaId",
                "wdaId",
                "lineTower",
                "startDate",
                // "endDate",
                "surveyorName",
                "surveyStatus",
                "action",
            ],

            options: {
                highlightMatches: true,
                headings: {
                    cityName: "City",

                    wcaId: "Zone",
                    wdaId: "Collection Division",
                    lineTower: "Line / Tower",
                    startDate: "Schedule Start Date",
                    // endDate: "Schedule End Date",
                    surveyorName: "Surveyor",
                    surveyStatus: "Survey Status",
                    action: "Action",
                },
                templates: {

                    startDate(row, query) {
                        return moment(query.startDate).format("DD-MM-YYYY");
                    },
                    endDate(row, query) {
                        return moment(query.endDate).format("DD-MM-YYYY");
                    },
                },
                perPage: 10,
                sortable: [
                    "cityName",
                    "wcaId",
                    "wdaId",
                    "lineTower",
                    "startDate",
                    // "endDate",
                    "surveyorName",
                    "surveyStatus",
                ],
                requestFunction: (request) => {
                    this.parameters.page = request.page;
                    this.parameters.limit = request.limit;
                    this.parameters.sortBy = "";
                    this.parameters.sortOrder = "";
                    this.parameters.searchString = "";
                    // this.parameters.startDate = this.startDateIso;
                    // this.parameters.endDate = this.endDateIso;
                    if (this.startDateIso) {
                        this.parameters.startDate = this.startDateIso;

                    } else {
                        delete this.parameters.startDate;

                    }
                    if (this.endDateIso) {
                        this.parameters.endDate = this.endDateIso;

                    } else {
                        delete this.parameters.endDate;

                    }
                    // if (this.startDateIso && this.endDateIso) {
                    //     this.parameters.startDate = this.startDateIso;
                    //     this.parameters.endDate = this.endDateIso;
                    // } else {
                    //     delete this.parameters.startDate;
                    //     delete this.parameters.endDate;
                    // }
                    if (request.orderBy) {
                        if (request.orderBy === "wcaId") {
                            this.parameters.sortBy = "collectionAreaDivision.areaName";
                        } else if (request.orderBy === "wdaId") {
                            this.parameters.sortBy = "collectionDivision.cdName";
                        } else if (request.orderBy === "lineTower") {
                            this.parameters.sortBy = 'collectionDivisionAreasDataCount';
                        } else if (request.orderBy === "cityName") {
                            this.parameters.sortBy = "cityData.cityName";
                        } else {
                            this.parameters.sortBy = request.orderBy;
                        }
                        if (request.ascending == 1) {
                            this.parameters.sortOrder = "asc";
                        } else {
                            this.parameters.sortOrder = "des";
                        }
                    }
                    if (request.query != "") {
                        this.parameters.searchString = request.query;
                    }
                    if (this.count === 0 && this.count1 === 0) {
                        this.count = null;
                        this.count1 = null;
                    }
                    this.loading = true;
                    return this.$surveyDataRepository
                        .getListByPost(this.parameters, this.filters)
                        .catch((error) => { });
                },

                responseAdapter: (response) => {
                    this.loading = false;
                    var dataRespSurveys = [];
                    let count;
                    response.data.response.forEach((element) => {
                        var surveysData = element;

                        surveysData["wcaId"] =
                            element.collectionAreaDivision != null ?
                                element.collectionAreaDivision.areaName :
                                null;
                        surveysData["wdaId"] =
                            element.collectionDivision != null ?
                                element.collectionDivision.cdName :
                                null;
                        surveysData["lineTower"] =
                            element.collectionDivisionAreasData.length;
                        let status = element.surveyStatus;
                        surveysData["surveyStatus"] =
                            status.charAt(0).toUpperCase() + status.slice(1);
                        surveysData["cityName"] = element.cityData.cityName;
                        dataRespSurveys.push(surveysData);
                    });
                    this.user1 = dataRespSurveys;
                    if (dataRespSurveys.length === 0) {
                        count = 0;
                    }
                    return {
                        data: dataRespSurveys,
                        count: response.data.total || count,
                    };
                },

                customFilters: [{
                    name: "custom_filter",
                    callback: function (row, query) {

                    },
                },],
                uniqueKey: "_id",
            },
        };
    },
    computed: {
        csvData() {
            return this.user1.map((item) => ({
                ...item,
            }));
        },

        addButtonClass() {
            if (this.surveysTable) {
                return this.surveysTable.count > this.surveysTable.limit ||
                    this.surveysTable.limit > 10 ?
                    "shift-add-left" :
                    "add-item";
            } else {
                return "add-item";
            }
        },
    },
    methods: {
        clearFilter() {
            this.parameters.startDate = "";
            this.parameters.endDate = "";
            this.startDateIso = "";
            this.endDateIso = "";
            this.clearFilters = {

                wasteCollectionArea: "",
                collectionDivision: "",
                surveyorId: "",
                surveyStatus: "",
                status: "",
            };
            this.date = {
                startDate: "",
                endDate: "",
            };

            // surveyorPointCYs = []
            this.count = null;
            this.count1 = 0;
            this.cityFilterCount = 0;
            this.zoneFilterCount = 0;
            this.surveyorFilterCount = 0;
            this.cdFilterCount = 0;
            this.statusFilterCount = 0;
            this.activeInactiveStatus = 0;
            this.sDateFilterCount = 0;
            this.checkedStatusType = []
            this.checkedAreas = [];
            this.checkedCds = [];

            this.filters = {};
            if (this.$store.state.auth.user.role.key === "superAdmin") {
                this.areas = [];
            }
            this.towersList = [];
            this.collectionDivisions = [];
            this.surveyorPoints = []
            this.$refs.surveysTable.refresh();
            if (this.adminCheck !== 'superAdmin') {
                this.getSurveyoys(this.$store.state.auth.user.cityId._id)
            }
        },

        startDate() {
            if (this.date.startDate && this.sDateFilterCount === 0) {
                this.count += 1;
                this.count1 += 1;
                this.sDateFilterCount = 1;
            }
            if (this.date.startDate === null && this.sDateFilterCount === 1) {
                this.count -= 1;
                this.count1 -= 1;
                this.sDateFilterCount = 0;
            }
            this.date.startDate ? this.startDateIso = new Date(this.date.startDate).toISOString() : this.startDateIso = "";
            this.$refs.surveysTable.refresh();
        },
        endDate() {

            // const eventData = this.date.endDate.split("-");
            // const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];

            this.endDateIso = new Date(this.date.endDate).toISOString();

            this.$refs.surveysTable.refresh();
            // }
        },

        closeAreaTableModal() {
            if (this.isAreaTable) {
                this.isAreaTable = !this.isAreaTable;
            }
        },
        showArea(row) {
            this.isAreaTable = true;
            this.towersList = [];

            row.collectionDivisionAreasData.forEach((tower) => {
                let list = {};
                list["towerName"] = tower.name;
                list["houses"] = tower.HousesData.length;
                this.towersList.push(list);
            });
        },

        activateSurveysModal(row) {
            let confirmtext;
            if (row.status === true) {
                confirmtext = "Deactivate";
            } else {
                confirmtext = "Activate";
            }
            swal({
                title: `Are you sure you want to ${confirmtext}!`,

                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: `Yes, ${confirmtext} it!`,
            }).then((result) => {
                if (result.value) {
                    this.activateSurveysPoint(row);
                }
            });
        },
        activateSurveysPoint(row) {
            let status1;
            let confirmtext;
            if (row.status === true) {
                confirmtext = "Deactivate";
                status1 = false;
            } else {
                confirmtext = "Activate";
                status1 = true;
            }

            let line = [];
            row.collectionDivisionAreasData.forEach((a) => {
                line.push(a._id);
            });

            const id = row._id;
            let surveys = {
                _id: row._id,
                wcaId: row.collectionAreaDivision._id,
                wdaId: row.collectionDivision._id,
                startDate: row.startDate,
                endDate: row.endDate,
                surveyorId: row.surveyor._id,
                status: status1,
                cityId: row.cityData._id,
                lineTower: line,
            };

            this.loading = true;
            return surveysService
                .updateSurveys(id, surveys)
                .then((response) => {
                    this.loading = false;
                    row.status = !row.status;
                    this.$snotify.success(`The has been marked ${confirmtext}.`);
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "Only allowed to change surveyor name when survey status is complete") {
                        const message = " Not allowed to change when survey status is complete"
                        this.$snotify.error(message, "Error!");
                    } else {
                        this.$snotify.error(error.data.message, "Error!");
                    }
                });
        },

        csvExport(arrData) {
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
                Object.keys(arrData[0]).join(";"),
                ...arrData.map((item) => Object.values(item).join(";")),
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "export.csv");
            link.click();
        },

        action(row) {
            this.$router.push({
                name: "surveysCreate",
                params: {
                    props: row.surveyStatus,
                    _id: row._id,

                },
                props: row,
            });
        },

        view(row) {
            this.$router.push({
                name: "surveyDetails",
                params: {
                    _id: row._id,
                },
                props: row,
            });
        },

        listRemove(value) {
            if (value.length == 0) {
                this.list = '';
            }
        },
        onLoaded() {
            this.surveysTable = this.$refs.surveysTable;
        },

        applyFilter(filter_val) {
            Event.$emit("vue-tables.customFilters::custom_filter", filter_val);
        },
        showWcaList() {
            this.cdShow = false;
            this.wcaShow = !this.wcaShow;
        },
        showCdList() {
            this.wcaShow = false;
            this.cdShow = !this.cdShow;
        },
        onChecked(option) {
            if (this.zoneFilterCount === 0) {
                this.zoneFilterCount = 1;
                this.count += 1;
            }
            this.clearFilters.wasteCollectionArea = option;
            let id = option.value;
            this.checkedAreas.push(id);
            this.wcaSelect(this.checkedAreas);
        },
        onRemove(option) {
            let id = option.value;
            this.checkedAreas = this.checkedAreas.filter((elemant) => elemant != id);
            if (this.zoneFilterCount === 1 && this.cdFilterCount === 1 && this.checkedAreas.length === 0) {
                this.count -= 2;
                this.zoneFilterCount = 0;
                this.cdFilterCount = 0;
            }
            if (this.zoneFilterCount === 1 && this.checkedAreas.length === 0 && this.cdFilterCount === 0) {
                this.count -= 1;
                this.zoneFilterCount = 0;
            }
            this.wcaSelect(this.checkedAreas);
            this.clearFilters.collectionDivision = '';
        },
        onCheckedSt(option) {
            if (this.statusFilterCount === 0) {
                this.statusFilterCount = 1;
                this.count += 1;
                this.count1 += 1;
            }
            if (this.$route.params.surveyStatus === 'complete') {
                const option = {
                    name: 'Complete',
                    value: [{
                        name: 'Complete',
                        value: 'complete'
                    }]
                };
                this.clearFilters.surveyStatus = option;
                this.filters["surveyStatus"] = ['complete'];
            } else if (this.$route.params.surveyStatus === 'scheduled') {
                const option = {
                    name: 'Pending',
                    value: [{
                        name: 'Pending',
                        value: 'pending'
                    },
                    {
                        name: 'Upcoming',
                        value: 'upcoming'
                    }]
                };
                this.clearFilters.surveyStatus = option;
                this.filters["surveyStatus"] = ['pending', 'upcoming'];
            } else {
                this.clearFilters.surveyStatus = option;
                let name = option.value;
                this.checkedStatusType.push(name);
                this.roleSelect(this.checkedStatusType);
            }
        },
        onRemoveSt(option) {
            let name = option.value;
            this.checkedStatusType = this.checkedStatusType.filter(
                (elemant) => elemant != name
            );
            if (this.statusFilterCount === 1 && this.checkedStatusType.length === 0) {
                this.statusFilterCount = 0;
                this.count -= 1;
                this.count1 -= 1;
            }
            if (this.filters.surveyStatus.length == 1) {
                delete this.filters.surveyStatus
            }
            else {
                this.filters["surveyStatus"] = this.checkedStatusType;
            }
            this.$refs.surveysTable.refresh();
        },
        roleSelect(surveyStatus) {
            this.filters["surveyStatus"] = surveyStatus.slice();
            this.$refs.surveysTable.refresh();
        },
        wcaSelect(wcaList) {
            let cdData = [];
            this.filters = {};
            if (wcaList.length > 0) {
                this.filters["areas"] = [...wcaList];
            }
            this.$refs.surveysTable.refresh();
            return wasteCollectionAreaService
                .getcollectionDivisionsByAreaId(wcaList)
                .then((response) => {
                    response.data.response.forEach((el) => {
                        let val = {};
                        val["name"] = el.divisionName.length > 20 ? el.divisionName.slice(0, 20) + "..." : el.divisionName;
                        val["value"] = el.divisionId;
                        cdData.push(val);
                    });
                    this.collectionDivisions = cdData.sort((a, b) =>
                        a.name.localeCompare(b.name)
                    );
                    const newList = this.collectionDivisions.map(e => e.value);
                    this.checkedCds = this.checkedCds.filter(e => newList.includes(e));
                    this.list = this.collectionDivisions.filter(elemant => {
                        if (this.checkedCds.includes(elemant.value))
                            return elemant;
                    })
                    this.clearFilters = {
                        ...this.clearFilters,  // destructure
                        collectionDivision: {
                            ...this.clearFilters.collectionDivision,
                            value: this.list
                        }
                    }
                });
        },
        onCheckedSy(option) {
            if (this.surveyorFilterCount === 0) {
                this.surveyorFilterCount = 1;
                this.count += 1;
            }
            this.clearFilters.surveyorId = option;
            let id = option.value;
            // this.surveyorPointCYs.push(id);
            if (this.surveyorPoints.length > 0) {
                this.filters["surveyorId"] = id;
            }
            this.$refs.surveysTable.refresh();
        },
        onRemoveSy(option) {
            if (this.surveyorFilterCount === 1) {
                this.surveyorFilterCount = 0;
                this.count -= 1;
            }
            let id = option.value;
            this.filters.surveyorId = "";
            this.$refs.surveysTable.refresh();
        },
        onSelectStatus(option) {
            if (this.activeInactiveStatus === 0) {
                this.activeInactiveStatus = 1;
                this.count += 1;
                this.count1 += 1;
            }
            if (this.$route.params.surveyStatus === 'scheduled') {
                const option = {
                    name: 'Acive',
                    value: [{
                        name: 'Active',
                        value: true
                    }]
                };
                this.clearFilters.status = option;
                this.filters["status"] = true;
            } else {
                this.clearFilters.status = option;
                this.filters["status"] = option.value;
                this.$refs.surveysTable.refresh();
            }
        },
        onRemoveStatus() {
            this.activeInactiveStatus = 0;
            this.count -= 1;
            this.count1 -= 1;
            this.clearFilters.status = "";
            this.filters["status"] = "";
            this.$refs.surveysTable.refresh();
        },
        onCheckedCd(option) {
            if (this.cdFilterCount === 0) {
                this.cdFilterCount = 1;
                this.count += 1;
            }
            this.clearFilters.collectionDivision = option;
            let id = option.value;
            this.checkedCds.push(id);
            this.filters = {
                areas: [...this.checkedAreas],
            };
            if (this.checkedCds.length > 0) {
                this.filters["divisions"] = this.checkedCds;
            }
            this.$refs.surveysTable.refresh();
            // this.getSurveyoys(this.checkedCds)
        },
        onRemoveCD(option) {
            this.filters = {
                areas: [...this.checkedAreas],
            };
            let id = option.value;
            this.checkedCds = this.checkedCds.filter((elemant) => elemant != id);

            if (this.checkedCds.length > 0) {
                this.filters["divisions"] = this.checkedCds;
            } else {
                this.count -= 1;
                this.cdFilterCount = 0;
                this.filters.divisions = "";
                this.$refs.surveysTable.refresh();
            }
            this.$refs.surveysTable.refresh();
        },
        getSurveyoys(cityId) {
            this.loading = true;
            let surveyoysList = [];
            return surveysService
                .getSurveyoysList(cityId)
                .then((response) => {
                    response.data.response.forEach((element) => {
                        if ((element.cityId = cityId)) {
                            surveyoysList.push({
                                name: element.firstName + " " + element.lastName,
                                value: element._id,
                            });
                        }
                    });
                    surveyoysList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.surveyorPoints = surveyoysList;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("Surveyoys-error:", error);
                });
        },
        getCityList() {
            const params = {};
            this.cityList = [];
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cities.push({
                                name: element.cityName.length > 20 ?
                                    element.cityName.slice(0, 20) + "..." : element.cityName,
                                value: element._id,
                            });
                        }
                    });
                    cities.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.cityList = cities;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");
                });
        },

        onCheckedCity(option) {
            // if(this.cityFilterCount === 1){
            //     this.count = 1;
            //     if(this.count1){
            //         this.count += this.count1;
            //     }
            //     this.zoneFilterCount = 0;
            //     this.cdFilterCount = 0;
            //     this.surveyorFilterCount = 0;
            // }
            // if(this.cityFilterCount === 0){
            //     this.cityFilterCount = 1;
            //     this.count += 1;
            // }
            this.checkedAreas = [];
            this.checkedCds = [];
            // this.surveyorPointCYs = []
            this.checkedStatusType = []
            this.clearFilters.surveyorId = ""
            this.clearFilters.surveyStatus = ""
            this.clearFilters.wasteCollectionArea = "";
            this.clearFilters.collectionDivision = "";
            this.areas = [];
            this.collectionDivisions = [];
            this.clearFilters.city = option;
            let cityId = option.value;
            // this.getArea(cityId);
            this.parameters.cityId = cityId;
            this.filters = {}
            this.getWCAList(cityId);
            this.getSurveyoys(cityId)
            if (this.$refs.surveysTable.refresh) {
                this.$refs.surveysTable.refresh();
            }

        },
        onRemoveCity(option) {
            this.cityFilterCount = 0;
            this.zoneFilterCount = 0;
            this.surveyorFilterCount = 0;
            this.count = this.count1;
            this.filters = {}
            this.areas = [];
            this.collectionDivisions = [];
            this.surveyorPoints = []
            let cityId = option.value;
            this.parameters.cityId = "";
            this.$refs.surveysTable.refresh();
            // this.startLocationList = []
            // this.endLocationList = []
        },

        getWCAList(id) {
            let data = [];
            return surveysService
                .getWasteCollectionAreaList(id)
                .then((response) => {
                    response.data.response.forEach((el) => {
                        let val = {};
                        val["name"] =
                            el.areaName.length > 20 ?
                                el.areaName.slice(0, 20) + "..." :
                                el.areaName;
                        val["value"] = el._id;
                        data.push(val);
                    });
                    this.areas = data.sort((a, b) => a.name.localeCompare(b.name));
                })
                .catch((error) => {
                    console.log("error", error);
                });
        },
    },
    mounted() {
        eventBus.$on('cityIdChanged', this.onCheckedCity);
        this.checkRole = this.$store.state.auth.user.role.name;
        if (this.$store.state.auth.user.role.key === "superAdmin") {
            this.columns.unshift("cityName");
        }
        eventBus.$on("DATA_PUBLISHED", (payload) => { });
        // this.getWasteAreas();
        this.getCityList();
    },
    beforeDestroy() {
        eventBus.$off('cityIdChanged', this.onCheckedCity);
    },
    created() {
        if(this.adminCheck !== 'cityAdmin' || this.adminCheck !== "subCityAdmin"){
            this.parameters.cityId = this.$store.state.auth.cityId.value
            this.getWCAList(this.parameters.cityId);
            this.getSurveyoys(this.parameters.cityId)

        }
        if (this.$route.params.surveyStatus) {
            this.onCheckedSt();
            this.onSelectStatus();
        }
        this.adminCheck = this.$store.state.auth.user.role.key
        let cityIdWCAList = this.$store.state.auth.user.cityId && this.$store.state.auth.user.cityId._id ? this.$store.state.auth.user.cityId._id : ""
        if (this.adminCheck !== 'superAdmin') {
            this.getWCAList(cityIdWCAList);
            this.getSurveyoys(cityIdWCAList)
        }
        this.clearFilters = {
            ...this.clearFilters,
            city: {
                ...this.clearFilters.city,
                value: this.$route.params.cityIds
            }
        }
        if (this.$route.params.cityIds && this.$route.params.cityIds.value) {
            if (this.clearFilters && this.clearFilters.city && this.clearFilters.city.value) {
                this.parameters.cityId = this.clearFilters.city.value.value;
                // if (this.cityFilterCount === 0) {
                //     this.cityFilterCount = 1;
                //     this.count += 1;
                // }
                if (this.$refs.surveysTable && this.$refs.surveysTable.refresh) {
                    this.$refs.surveysTable.refresh();
                }
            }
        }
    },
};
</script>
    
<style>
.sorting {
    position: absolute;
    left: 319px;
    z-index: 1000;
    width: 200px;
}

.box-body {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.gradientbt {
    background: #35A2FE;
    color: white;
}

/* new css */

.toggle {
    --width: 64px;
    --height: calc(var(--width) / 3);

    position: relative;
    display: inline-block;
    width: var(--width);
    height: var(--height);
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    border-radius: var(--height);
    cursor: pointer;
    margin-bottom: 0px;
    position: relative;
    top: 2px;
}

.toggle input {
    display: none;
}

.toggle .slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--height);
    background-color: #ccc;
    transition: all 0.4s ease-in-out;
}

.toggle .slider::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--height));
    height: calc(var(--height));
    border-radius: calc(var(--height) / 2);
    background-color: #fff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.3);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked+.slider {
    background-color: #35A2FE;
}

.toggle input:checked+.slider::before {
    transform: translateX(calc(var(--width) - var(--height)));
}

.toggle .labels {
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 10px;
    font-family: sans-serif;
    transition: all 0.4s ease-in-out;
}

.toggle .labels::after {
    content: attr(data-off);
    position: absolute;
    right: 5px;
    color: #4d4d4d;
    opacity: 1;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle .labels::before {
    content: attr(data-on);
    position: absolute;
    left: 5px;
    color: #ffffff;
    opacity: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    transition: all 0.4s ease-in-out;
}

.toggle input:checked~.labels::after {
    opacity: 0;
}

.toggle input:checked~.labels::before {
    opacity: 1;
}

.active_wrp {
    display: flex;
    align-items: center;
}

.surveysTable_scroll .active_wrp a {
    flex: 0 0 10% !important;
    color: #35A2FE !important;
    margin-right: 10px !important;
}

.surveysTable_scroll_new .active_wrp a {
    flex: auto !important;
    width: auto;
}

.surveysTable_scroll .active_wrp a.fa.fa-eye {
    margin-right: 20px !important;
}

.surveysTable_scroll .table-responsive table tr th:nth-child(5) {
    width: 150px;
}

.surveysTable_scroll_new .table-responsive table tr th:nth-child(5) {
    width: auto !important;
}

.surveysTable_scroll .table-responsive {
    overflow-x: auto !important;
}

.surveysTable_scroll .table-responsive table {
    min-width: 1400px !important;
}

.table_scroll {
    height: 200px;
    overflow: auto;
    padding: 0px 10px;
    overflow-x: hidden !important;
}

/* width */
.table_scroll::-webkit-scrollbar {
    width: 5px;
}

/* Track */
.table_scroll::-webkit-scrollbar-thumb {
    background: #888;
}

.password-popup-width h1 {
    font-size: 22px;
    margin-bottom: 10px;
    font-weight: 600;
}

th,
td {
    border: 1px solid black;
    padding: 5px;
    text-align: left;
}

.password-popup {
    height: 100%;
    width: 100%;
    z-index: 10;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    text-align: center;
    box-shadow: rgb(100 100 111 / 20%) 0px 7px 29px 0px;
    z-index: 9999;
    background-color: rgb(0 0 0 / 50%);
    display: flex;
    align-items: center;
    justify-content: center;
}

.tablePopUp {
    border-collapse: collapse;
    border: 1px solid black;
    table-layout: auto;
    width: 460px !important;
}

.cancelButton {
    background-color: #f44336;
    border-radius: 8px;
    left: 47%;
    position: fixed;
    bottom: 100px;
}

.password-popup-width {
    padding-top: 0px;
    background: #fff;
    width: 500px;
    height: 300px;
    padding: 0px !important;
    border-radius: 10px;
    position: relative;
}

.password-popup-width .toggle {
    box-shadow: none;
    border: none;
    width: auto;
    position: absolute;
    right: 10px;
    top: 20px;
}

.password-popup-width .toggle svg {
    width: 22px;
    height: 22px;
}

h4.heading_pop {
    background: #f1f1f1;
    padding: 20px;
    margin: 0;
    border-bottom: 1px solid #ddd;
    text-align: left;
    margin-bottom: 10px;
    border-radius: 5px 5px 0px 0px;
}

.datedrop_boxs_wrapper {
    position: relative;
    z-index: 2;
}

.datedrop_boxs_inner {
    position: absolute;
    right: 185px;
    top: 5px;
}

.datedrop_boxs_inner_survey {
    right: 85px !important;
}

.datedrop_boxs_inner button {
    background: #35A2FE;
    /* color: #fff; */
    border: 0;
    padding: 5px 20px;
    border-radius: 5px;
}

.datedrop_boxs_inner_survey button {
    padding: 6px 20px !important;
    width: max-content;
    margin-right: 65px;
}

.datedrop_boxs_inner_survey {
    top: 10px !important;
}

.datedrop_rel_inner .d-flex {
    background: #fff;
    padding: 10px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.flex {
    display: flex;
}

.multiselected {
    min-width: 145px;
    max-width: 146px;
}

.selectwca_wrp .multiselect__tags {
    min-height: 26px;
    display: block;
    padding: 4px 35px 0px 7px;
    border-radius: 5px;
    border: 1px solid #35A2FE;
    background: #fff;
    display: flex;
    align-items: center;
    margin-right: 10px;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    /* border: 1px solid #bcf5db; */
    font-weight: normal;
}

.selectwca_wrp .multiselect__select:before {
    top: 50%;
}

.selectwca_wrp .multiselect__tag {
    padding: 4px 15px 4px 10px;
}

.selectwca_wrp .multiselected {
    min-width: 33.8%;
}

.selectwca_wrp .multiselect__tags-wrap {
    /* background: #fff;  */
    overflow: hidden;
    overflow-y: auto;
    max-height: 70px;
    position: absolute;
    top: 0;
    left: 0;
    padding: 6px 10px 0px;
    z-index: 1;
    width: 260px;
    display: flex;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}

.selectwca_wrp .multiselect__option--selected {
    color: #41b883;
    font-weight: 700;
}

.selectwca_wrp .multiselect__option--selected.multiselect__option--highlight {
    background: #161616;
    color: #fff;
}

.selectwca_wrp .multiselect__tags-wrap::-webkit-scrollbar {
    width: 5px;
}

.selectwca_wrp .multiselect__tags-wrap::-webkit-scrollbar-thumb {
    background: #888;
}

.disableEdit a {
    pointer-events: none;
    color: #94bdaa !important;
}

.main_select_wrp_survey .multiselected {
    min-width: 50.5%;
}

.clearButton {
    margin-right: 33px;
    opacity: 0.8;
    color: blue;
    text-decoration: underline;
    font-size: large;
}

.select_date_wrp .datedrop_boxs {
    position: static;
    width: 100%;
    padding: 0px;
    box-shadow: none;
    border: transparent;
}

.select_date_wrp {
    margin-top: 20px;
}

.select_date_wrp .datedrop_boxs_wrp {
    float: initial;
    background: transparent;
    margin-right: 0;
}

.dates_left label {
    color: #333;
}

.dates_left {
    flex: 0 0 32.5%;
    margin-right: 10px;
}

.clearButton {
    margin-right: 33px;
    opacity: 0.8;
    color: blue;
    text-decoration: underline;
    font-size: large;
}

.survey_colm_fixs .VueTables__table tr th:nth-child(4) {
    max-width: 128px;
}

.Complete {
    color: #00BD08;
}

.Ongoing {
    color: #0072F8;
}

.Pending {
    color: #E1BD00;
}

.Upcoming {
    color: #FF5C00;
}

@media(max-width:1399px) {
    .surveysTable_scroll .table-responsive {
        overflow-x: auto !important;
    }

    .surveysTable_scroll .table-responsive table {
        min-width: 1400px !important;
    }
}

@media(max-width:767px) {
    .datedrop_boxs_inner_survey .filter_wrpp {
        margin-bottom: 10px;
    }

    .datedrop_boxs_inner_survey {
        position: static !important;
    }
}
</style>
    


// WEBPACK FOOTER //
// surveys.vue?cae11f52